import MobileDetect from 'mobile-detect';
import { AppBridge } from './app-bridge';

const mobileDetect = new MobileDetect(navigator.userAgent);

export const IOS = 'IOS';
export const ANDROID = 'ANDROID';
export const OTHER = 'OTHER';
export const IN_APP_WEBVIEW = 'IN_APP_WEBVIEW';
export const BROWSER = 'BROWSER';

export const deviceOS = () => {
  switch (mobileDetect.os()) {
    case 'iOS':
      return IOS;
    case 'AndroidOS':
      return ANDROID;
    default:
      return OTHER;
  }
};

export const devicePlateForm = () => {
  if (deviceOS() === OTHER) {
    return 'desktop';
  } else {
    return 'mobile';
  }
};

export const deviceOSType = (valueIOS, valueAndroid, valueDesktop) => {
  switch (deviceOS()) {
    case IOS:
      return valueIOS;
    case ANDROID:
      return valueAndroid;
    case OTHER:
      return valueDesktop;
    default:
      return '';
  }
};

export const deviceIsApple = () => {
  const device = ['iPhone', 'iPad', 'Mac'];
  return device.find(d => navigator.platform.indexOf(d) !== -1 || navigator.platform.includes(d));
};

export const deviceType = () => {
  const useragent = navigator.userAgent;
  const rules = [
    'WebView',
    '(iPhone|iPod|iPad)(?!.*Safari/)',
    'Android.*(wv|.0.0.0)',
    'Autopass/(.*)',
    'MyRewards/(.*)',
  ];
  const regex = new RegExp(`(${rules.join('|')})`, 'ig');
  const isMatch = Boolean(useragent.match(regex));
  if (isMatch) {
    return IN_APP_WEBVIEW;
  } else {
    return BROWSER;
  }
};

export const isAutopassInAppWebview = () => {
  const useragent = navigator.userAgent;
  const regex = new RegExp('Autopass/(.*)', 'ig');
  return Boolean(useragent.match(regex));
};

export const isCathayMyRewardsInAppWebview = () => {
  const useragent = navigator.userAgent;
  const regex = new RegExp('MyRewards/(.*)', 'ig');
  return Boolean(useragent.match(regex));
};

export const isCpcPayInAppWebview = () => {
  const useragent = navigator.userAgent;
  const regex = new RegExp('CpcPay/(.*)', 'ig');
  return Boolean(useragent.match(regex));
};

export const isSupportAppVersion = (version, appVersionReplace) => {
  const appBridge = new AppBridge({});
  const appVersion = appBridge.app_version || appVersionReplace;

  // current app version
  let appMajorNum = parseInt(appVersion.split('.')[0]);
  let appMinorNum = parseInt(appVersion.split('.')[1]);

  // specify enabled version
  let expectMajorNum = parseInt(version.split('.')[0]);
  let expectMinorNum = parseInt(version.split('.')[1]);

  if (appMajorNum === expectMajorNum) {
    return appMinorNum >= expectMinorNum;
  }

  return appMajorNum > expectMajorNum;
};
